export default {
  resources: {
    subscriptions: {
      notification: {
        cancelled_success: "Assinatura cancelada com sucesso",
        cancelled_failure: "Não foi possível cancelar a assinatura"
      }
    }
  }
};